import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import lib from 'lib/commons';
import config from 'config/common';
import dayjs from 'dayjs';
import ReactTooltip from 'react-tooltip';
import { useReward } from 'react-rewards';

import ModalMission from './ModalMission';
import ModalReceivedGifts from './ModalReceivedGifts';
import ModalReceivedGift from './ModalReceivedGift';
import ModalJackpot from './ModalJackpot';

let tm;
let time = 0;
let turns = 0;

const Spin = ({
	data: {
		user: {
			id: userId = null,
			name = '',
			fc = 0,
			mc = 0,
			accumulation = 0,
			free_spin = 0,
			price_type = null,
			free_type = null,
			special_spins = {},
			club_spins_claimed = 0,
		} = {},
		isSharing = false,
		isSpinning = false,
		isCheckingMatch = false,
		isRefreshing = false,
		isClaimingClub = false,
		eventStarted = 0,
		spinSettings = [],
		jackpotValue = 0,
		playNormal = 0,
		winnerJackpot,
		winnerSemiJackpot,
		delta,
		currentDatetime,
		special_date = false,
	},
	share,
	checkMatch,
	spin,
	refresh,
	claimClub,
}) => {
	const parsed = queryString.parse(location.search);

	const { reward: confettiReward, isAnimating: isConfettiAnimating } =
		useReward('confettiReward', 'confetti', {
			elementCount: 200,
			zIndex: 20,
			elementSize: 10,
			spread: 100,
		});

	const { reward, isAnimating: isConfettiAnimating2 } = useReward(
		'confettiReward2',
		'confetti',
		{ elementCount: 200, zIndex: 20, elementSize: 10, spread: 100 }
	);

	useEffect(() => {
		ReactTooltip.rebuild();
	});

	useEffect(() => {
		if (winnerJackpot && winnerJackpot?.nickname) {
			setTimeout(() => {
				document.getElementById('confettijackpot').click();
			}, 500);
		}
	}, [winnerJackpot]);

	useEffect(() => {
		if (winnerSemiJackpot && winnerSemiJackpot?.nickname) {
			setTimeout(() => {
				document.getElementById('confettiminijackpot').click();
			}, 1500);
		}
	}, [winnerSemiJackpot]);

	useEffect(() => {
		let shared = parsed['spin-shared'];
		if (userId && shared == 'true') {
			share();
		}
	}, [userId]);

	useEffect(() => {
		if (currentDatetime) {
			if (dayjs().add(delta, 'ms') < dayjs('2023-11-11 23:59:59')) {
				setInterval(() => {
					if (dayjs().add(delta, 'ms') >= dayjs('2023-11-11 23:59:59')) {
						window.location.reload();
					}
				}, 1000);
			}
			if (dayjs().add(delta, 'ms') < dayjs('2023-11-11 00:00:00')) {
				setInterval(() => {
					if (dayjs().add(delta, 'ms') >= dayjs('2023-11-11 00:00:00')) {
						window.location.reload();
					}
				}, 1000);
			}
		}
	}, [currentDatetime]);

	const [typeMoneyCur, setTypeMoneyCur] = useState(1); // 1 - FC, 2 - MC
	const [gifts, setGifts] = useState([]);
	const [totalNumberMedal, setTotalNumberMedal] = useState([0, 0, 0, 0, 0]);
	const [rewardsSpin, setRewardsSpin] = useState([]);
	const [isDisableAnimation, setIsDisableAnimation] = useState(false);
	const [playMatch, setPlayMatch] = useState(0);

	const [modalMission, setModalMission] = useState(false);
	const closeModalMission = () => setModalMission(false);

	const [modalJackpot, setModalJackpot] = useState(false);
	const closeModalJackpot = () => setModalJackpot(false);

	const [showModalReceivedGifts, setShowModalReceivedGifts] = useState(false);
	const [showModalReceivedGift, setShowModalReceivedGift] = useState(false);

	const [isShowBanner, setIsShowBanner] = useState(null);

	useEffect(() => {
		if (userId) {
			setIsShowBanner(false);
		} else {
			setIsShowBanner(true);
		}
	}, [userId]);

	const handleChangeTypeMoney = (e, type) => {
		e.preventDefault();
		setTypeMoneyCur(type);
	};

	const handleRefresh = (e) => {
		e.preventDefault();

		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (isRefreshing) {
			return false;
		}

		refresh();
	};

	const shareCustom = () => {
		let quote = config.shareQuote;
		let hashtag = config.shareHashtag;
		let shareLink =
			'https://www.facebook.com/dialog/share?app_id=3504952839719618&display=touch&href=' +
			`https://${config.domain}%2F` +
			'&redirect_uri=https%3A%2F%2F' +
			config.domain +
			'%2F%3Fspin-shared=true' +
			'&hashtag=%23' +
			hashtag +
			'&quote=' +
			quote;

		window.location = shareLink;
	};

	const handleShare = (e) => {
		e.preventDefault();

		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (isSharing || isSpinning) {
			return false;
		}

		if (lib.isFbBrowser()) {
			share(shareCustom);
		} else {
			if (lib.isMobile()) {
				shareCustom();
			} else {
				FB.ui(
					{
						method: 'share',
						href: config.baseUrl,
						hashtag: '#' + config.shareHashtag,
						quote: config.shareQuote,
						display: 'iframe',
					},
					(response) => {
						// if (response && !response.error_message) {
						share();
						// } else {
						// 	lib.showMessage('Vui lòng chia sẻ để nhận lượt');
						// }
					}
				);
			}
		}
	};

	const handleMission = (e) => {
		e.preventDefault();

		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (isSpinning || isCheckingMatch) {
			return;
		}
		checkMatch((re) => {
			setPlayMatch(re);
			setModalMission(true);
		});
	};

	const handleClaimClub = (e) => {
		e.preventDefault();

		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (isSpinning || isClaimingClub) {
			return;
		}

		if (club_spins_claimed > 0) {
			lib.showMessage('Bạn đã cập nhật ưu đãi rồi.');
			return false;
		}

		claimClub((re) => {
			// setPlayMatch(re);
			// setModalMission(true);
		});
	};

	// 0: free, 1: 1, 2: 10, 3: 50
	// “1”: Jackpot, “2”: FC, “3”: BP, “4”: Class, “5”: Pack
	const handleSpin = (e, spin_type) => {
		e.preventDefault();

		if (!eventStarted) {
			lib.showMessage(config.demoMsg);
			return false;
		}

		if (!userId) {
			lib.login();
			return false;
		}

		if (spin_type === 0 && free_spin < 1) {
			lib.showMessage('Bạn không có lượt chơi miễn phí');
			return false;
		}

		if (isSpinning) {
			return;
		}
		setRewardsSpin([]);
		setTotalNumberMedal([0, 0, 0, 0, 0]);

		spin(spin_type, typeMoneyCur, isDisableAnimation, (re) => {
			let idRewards = [];
			setGifts(re?.spin_results);
			let idMedals =
				re?.spin_results.length > 1
					? re?.spin_results[re?.spin_results.length - 1]?.items
					: re?.spin_results[0]?.items;

			var resultTotal = [0, 0, 0, 0, 0];

			const element =
				re?.spin_results[re?.spin_results.length - 1]?.spin_result_reward_id;
			idRewards.push(element);

			if (isDisableAnimation) {
				for (let i = 0; i < idMedals.length; i++) {
					let element = idMedals[index];
					if (idMedals[index] == 3) {
						element = 1;
					}
					if (idMedals[index] == 1) {
						element = 3;
					}
					resultTotal[element - 1] = resultTotal[element - 1] + 1;
				}
				setRewardsSpin(idRewards);
				setTotalNumberMedal(resultTotal);

				if (re?.spin_results.length > 1) {
					setTimeout(() => {
						setShowModalReceivedGifts(true);
					}, 1200);
				} else {
					const checkJackpot =
						re?.spin_results.find(
							(item) =>
								item?.spin_result_type == 2 || item?.spin_result_type == 3
						) || '';
					if (checkJackpot) {
						setModalJackpot(true);
					} else {
						setTimeout(() => {
							setShowModalReceivedGift(true);
						}, 1200);
					}
				}
			} else {
				for (let index = 0; index < idMedals.length; index++) {
					let element = idMedals[index];
					if (idMedals[index] == 3) {
						element = 1;
					}
					if (idMedals[index] == 1) {
						element = 3;
					}

					const typeMedal = Math.floor(Math.random() * (3 - 1 + 1) + 1);

					if (index === 0) {
						$(`.img-ball`).css('animation', 'none');
						setTimeout(() => {
							$(`.img-ball`).css(
								'animation',
								`type${typeMedal}medal${element} 0.5s linear`
							);
						}, 100);
						setTimeout(() => {
							resultTotal[element - 1] = resultTotal[element - 1] + 1;
							setTotalNumberMedal([...resultTotal]);
						}, 600);
					} else {
						setTimeout(() => {
							$(`.img-ball`).css('animation', 'none');
						}, 600 * index);
						setTimeout(() => {
							$(`.img-ball`).css(
								'animation',
								`type${typeMedal}medal${element} 0.5s linear`
							);
						}, 600 * index + 100);
						setTimeout(() => {
							resultTotal[element - 1] = resultTotal[element - 1] + 1;
							setTotalNumberMedal([...resultTotal]);
						}, 600 * index + 550);
					}
				}

				setTimeout(() => {
					setRewardsSpin(idRewards);
				}, 2500);

				if (re?.spin_results.length > 1) {
					setTimeout(() => {
						setShowModalReceivedGifts(true);
					}, 2800);
				} else {
					const checkJackpot =
						re?.spin_results.find(
							(item) =>
								item?.spin_result_type == 2 || item?.spin_result_type == 3
						) || '';
					if (checkJackpot) {
						setModalJackpot(true);
					} else {
						setTimeout(() => {
							setShowModalReceivedGift(true);
						}, 2800);
					}
				}
			}
		});
	};

	const rewards3Medals =
		spinSettings.length > 0 ? spinSettings.slice(0, 5) : []; // Qùa 3 mặt giống nhau
	const rewards2Medals =
		spinSettings.length > 0 ? spinSettings.slice(5, 10) : []; // Quà 2 mặt giống nhau
	const rewards1Medals =
		spinSettings.length > 0 ? spinSettings[spinSettings.length - 1] : null; // Quà 3 mặt khác nhau

	let isSpecialDay =
		dayjs().add(delta, 'ms').format('DD-MM-YYYY') ==
		dayjs('2022-12-12').format('DD-MM-YYYY')
			? 1
			: 0;

	return (
		<>
			<div className="section section--1">
				{isShowBanner === true && (
					<div className="wrap-video">
						<video autoPlay muted loop>
							<source
								src="https://cdn.vn.garenanow.com//fo3vn/project/playerPack/BilacT62024Open.webm"
								type='video/webm;codecs="vp8, vorbis"'
							/>
						</video>
						<img
							src="https://cdn.vn.garenanow.com//fo3vn/project/playerPack/BilacT62024Open.gif"
							alt=""
						/>

						{/* <div className="date-event">24.07 - 31.07</div> */}
					</div>
				)}
				{isShowBanner === false && (
					<>
						<div className={`menu-center${lib.isInGame() ? ' ingame' : ''}`}>
							{/* <a
								href="#"
								className="btn-club"
								onClick={(e) => handleClaimClub(e)}
								//
								data-tip={`Ưu đãi khi tạo CLB 23.4 - 12.5 ( Tối đa: 1 lần)`}
								data-place="right"
							>
								<img
									src="https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2024/T4/CLB/club_bilac.png"
									alt=""
								/>
							</a> */}
							<a
								href="#"
								className="btn-mission"
								onClick={(e) => handleMission(e)}
							>
								<img src="/images/btn-mission.png?v=3" alt="" />
							</a>
							<a href="#" className="btn-share" onClick={(e) => handleShare(e)}>
								<img src="/images/btn-share.png?v=3" alt="" />
							</a>
						</div>
						<div className="wrap-video">
							<video autoPlay muted loop>
								<source
									src="https://cdn.vn.garenanow.com//fo3vn/project/playerPack/BilacT62024Loop.webm"
									type='video/webm;codecs="vp8, vorbis"'
								/>
							</video>
							<img
								src="https://cdn.vn.garenanow.com//fo3vn/project/playerPack/BilacT62024Loop.gif"
								alt=""
							/>
						</div>
						<div className="spin">
							<div className="spin__wrap">
								<div className="spin__top">
									<div className="spin__congrat">
										<div className="spin__congrat--jackpot">
											<div className="spin__congrat--gift">
												<img src="/images/gift-box.png" alt="" />
											</div>
											<div className="spin__congrat--content">
												{winnerJackpot?.nickname ? (
													<>
														Chúc mừng HLV {winnerJackpot?.nickname} đã nhận được{' '}
														{winnerJackpot?.value}
														<button
															disabled={isConfettiAnimating}
															onClick={() => {
																confettiReward();
															}}
															className="confetti"
															id="confettijackpot"
														>
															<span id="confettiReward" />
														</button>
													</>
												) : (
													<>
														<span className="fifa">EA Sports FC Online</span>
													</>
												)}
											</div>
										</div>
										<div className="spin__congrat--reward">
											<div className="spin__congrat--gift">
												<img src="/images/gift-box.png" alt="" />
											</div>
											<div className="spin__congrat--content">
												{winnerSemiJackpot?.nickname ? (
													<>
														Chúc mừng HLV {winnerSemiJackpot?.nickname} đã nhận
														được {winnerSemiJackpot?.value}
														<button
															disabled={isConfettiAnimating2}
															onClick={() => {
																reward();
															}}
															className="confetti2"
															id="confettiminijackpot"
														>
															<span id="confettiReward2" />
														</button>
													</>
												) : (
													<>
														<span className="fifa">EA Sports FC Online</span>
													</>
												)}
											</div>
										</div>
									</div>
									<div className="spin__jackpot">
										<img src="/images/bg-jackpot.png" alt="" />
										<div className="spin__jackpot--text">
											<img src="/images/jackpot.png?v=1" alt="" />
										</div>
										<div className="spin__jackpot--total">
											{jackpotValue || 0} {typeMoneyCur == 1 ? 'FC' : 'MC'}
										</div>
										<div className="spin__jackpot--type">
											<img
												src={`/images/icon-${
													typeMoneyCur == 1 ? 'fc' : 'mc'
												}.png`}
												alt=""
											/>
										</div>
									</div>
									<div className="spin__info-money">
										<ul>
											<li>
												FC: {fc || 0} FC{' '}
												<a href="#" onClick={(e) => handleRefresh(e)}>
													<img src="/images/refresh.png" alt="" />
												</a>
											</li>
											<li>
												MC: {mc || 0} MC{' '}
												<a href="#" onClick={(e) => handleRefresh(e)}>
													<img src="/images/refresh.png" alt="" />
												</a>
											</li>
											<li>Tổng điểm Lucky Star: {accumulation || 0} điểm</li>
										</ul>
									</div>
								</div>

								<div className="spin__foosball-table">
									<img
										src="/images/foosball-table.png"
										alt=""
										className="img-foosball-table"
									/>
									<div className="spin__medal">
										{Array(5)
											.fill()
											.map((_, index) => {
												let medalId = index + 1;
												if (index + 1 == 1) {
													medalId = 3;
												}
												if (index + 1 == 3) {
													medalId = 1;
												}
												return (
													<div
														className={`spin__medal--item${
															totalNumberMedal[index] != 0 ? ' active' : ''
														}`}
													>
														<img
															src={`/images/medal${medalId}.png?v=1`}
															alt=""
														/>
														{totalNumberMedal[index] != 0 && (
															<span>x{totalNumberMedal[index]}</span>
														)}
													</div>
												);
											})}
									</div>
									<div className="spin__players">
										{Array(9)
											.fill()
											.map((_, key) => {
												let isPlayerYellow = [1, 2, 6, 7].includes(key);

												return (
													<div
														className={`spin__players--${key + 1}`}
														key={key}
													>
														<img
															src={`/images/player-${
																isPlayerYellow ? 'yellow' : 'red2'
															}.png`}
															alt=""
														/>
													</div>
												);
											})}
									</div>
									<div className="spin__ball">
										<img src="/images/ball.png" alt="" className="img-ball" />
									</div>

									<div className="spin__play-type">
										<p>Số lượt chơi miễn phí: {free_spin || 0}</p>
										<div>
											<span>Chơi bằng</span>
											<a href="#" onClick={(e) => handleChangeTypeMoney(e, 1)}>
												<img
													src={`/images/${
														typeMoneyCur == 1 ? 'checked' : 'unchecked'
													}.png`}
													alt=""
												/>
												FC
											</a>
											<a href="#" onClick={(e) => handleChangeTypeMoney(e, 2)}>
												<img
													src={`/images/${
														typeMoneyCur == 2 ? 'checked' : 'unchecked'
													}.png`}
													alt=""
												/>
												MC
											</a>
										</div>
									</div>

									<div className="spin__actions">
										<a
											href="#"
											className={`spin__actions--1${
												isSpinning ? ' disable' : ''
											}`}
											onClick={(e) => handleSpin(e, 0)}
										>
											Chơi miễn phí
											{free_type == 'special_date' &&
												special_spins[0] === undefined && (
													<span
														className="btn-special"
														data-tip=""
														data-for="guide-text-free"
													>
														11.11
													</span>
												)}
										</a>
										{price_type == 'first_pay' && (
											<a
												href="#"
												className={`spin__actions--2${
													isSpinning ? ' disable' : ''
												}`}
												onClick={(e) => handleSpin(e, 1)}
											>
												Chơi lần đầu{' '}
												<span>10{typeMoneyCur == 1 ? 'FC' : 'MC'}</span>
												{special_date && (
													<span
														className="btn-special"
														data-tip=""
														data-for="guide-text-first-time"
													>
														11.11
													</span>
												)}
											</a>
										)}
										{price_type != 'first_pay' && (
											<>
												<a
													href="#"
													className={`spin__actions--2${
														isSpinning ? ' disable' : ''
													}`}
													onClick={(e) => handleSpin(e, 1)}
												>
													Chơi 1 lần{' '}
													<span>20{typeMoneyCur == 1 ? 'FC' : 'MC'}</span>
													{(price_type == 'special_date' || special_date) &&
														typeMoneyCur == 1 &&
														special_spins[1] === undefined && (
															<span
																className="btn-special"
																data-tip=""
																data-for="guide-text-special-day"
															>
																11.11
															</span>
														)}
												</a>
												<a
													href="#"
													className={`spin__actions--3${
														isSpinning ? ' disable' : ''
													}`}
													onClick={(e) => handleSpin(e, 2)}
												>
													Chơi 10 lần{' '}
													<span>190{typeMoneyCur == 1 ? 'FC' : 'MC'}</span>
													{(price_type == 'special_date' || special_date) &&
														typeMoneyCur == 1 &&
														special_spins[2] === undefined && (
															<span
																className="btn-special"
																data-tip=""
																data-for="guide-text-special-day"
															>
																11.11
															</span>
														)}
												</a>
												<a
													href="#"
													className={`spin__actions--4${
														isSpinning ? ' disable' : ''
													}`}
													onClick={(e) => handleSpin(e, 3)}
												>
													Chơi 50 lần{' '}
													<span>900{typeMoneyCur == 1 ? 'FC' : 'MC'}</span>
													{(price_type == 'special_date' || special_date) &&
														typeMoneyCur == 1 &&
														special_spins[3] === undefined && (
															<span
																className="btn-special"
																data-tip=""
																data-for="guide-text-special-day"
															>
																11.11
															</span>
														)}
												</a>
											</>
										)}
									</div>
								</div>

								<div className="spin__rewards">
									<div className="title">
										<img src="/images/title.png" alt="" />
									</div>
									<div className="spin__list">
										<div className="spin__reward-level spin__reward-level--1">
											{rewards3Medals.length > 0 &&
												rewards3Medals.map((item, index) => {
													return (
														<div
															className="spin__line spin__line--1"
															key={index}
														>
															<div className="spin__total-medal spin__total-medal--1">
																<div>
																	<img
																		src={`/images/medal${index + 1}.png`}
																		alt=""
																	/>
																	<span>x3</span>
																</div>
															</div>
															<div className="spin__wrap-rewards spin__wrap-rewards--1">
																{item?.rewards.length > 0 &&
																	item?.rewards.map((reward, key) => {
																		const isActive = rewardsSpin.includes(
																			reward?.id
																		)
																			? true
																			: false;
																		const desc =
																			index == 0
																				? typeMoneyCur == 1
																					? 'Giải đặc biệt: ' +
																					  jackpotValue +
																					  ' FC'
																					: 'Giải đặc biệt: ' +
																					  jackpotValue +
																					  ' MC'
																				: reward?.desc;

																		return (
																			<div key={key}>
																				<img
																					src={lib.replaceNewString(
																						reward?.image,
																						'.png',
																						'_s.png'
																					)}
																					alt=""
																					data-tip={desc}
																					className={isActive ? ' active' : ''}
																				/>{' '}
																				{index == 0
																					? typeMoneyCur == 1
																						? 'Giải đặc biệt: ' +
																						  jackpotValue +
																						  ' FC'
																						: 'Giải đặc biệt: ' +
																						  jackpotValue +
																						  ' MC'
																					: ''}
																			</div>
																		);
																	})}
															</div>
															<div className="spin__point spin__point--1">
																Điểm +{item?.accumulation_point}
															</div>
														</div>
													);
												})}
										</div>

										<div className="spin__reward-level spin__reward-level--2">
											{rewards2Medals.length > 0 &&
												rewards2Medals.map((item, index) => {
													return (
														<div
															className="spin__line spin__line--2"
															key={index}
														>
															<div className="spin__total-medal spin__total-medal--2">
																<div>
																	<img
																		src={`/images/medal${index + 1}.png`}
																		alt=""
																	/>
																	<span>x2</span>
																</div>
																<div>
																	<img
																		src="/images/medal-random.png"
																		alt=""
																		className="medal-random"
																	/>
																	<span>x1</span>
																</div>
															</div>
															<div className="spin__wrap-rewards spin__wrap-rewards--2">
																{item?.rewards.length > 0 &&
																	item?.rewards.map((reward, key) => {
																		const isActive = rewardsSpin.includes(
																			reward?.id
																		)
																			? true
																			: false;

																		const desc =
																			index == 0
																				? typeMoneyCur == 1
																					? 'Giải phụ: ' +
																					  Math.floor(jackpotValue / 10) +
																					  ' FC'
																					: 'Giải phụ: ' +
																					  Math.floor(jackpotValue / 10) +
																					  ' MC'
																				: reward?.desc;

																		const img =
																			typeMoneyCur == 1
																				? lib.replaceNewString(
																						reward?.image,
																						'MC.png',
																						'FC_s.png'
																				  )
																				: lib.replaceNewString(
																						reward?.image,
																						'FC.png',
																						'MC_s.png'
																				  );

																		return (
																			<div>
																				<img
																					src={lib.replaceNewString(
																						reward?.image,
																						'.png',
																						'_s.png'
																					)}
																					alt=""
																					data-tip={desc}
																					className={isActive ? ' active' : ''}
																				/>{' '}
																				{index == 0
																					? typeMoneyCur == 1
																						? 'Giải phụ: ' +
																						  Math.floor(jackpotValue / 10) +
																						  ' FC'
																						: 'Giải phụ: ' +
																						  Math.floor(jackpotValue / 10) +
																						  ' MC'
																					: ''}
																			</div>
																		);
																	})}
															</div>
															<div className="spin__point spin__point--2">
																Điểm <br />+{item?.accumulation_point}
															</div>
														</div>
													);
												})}
										</div>

										<div className="spin__reward-level spin__reward-level--3">
											<div className="spin__line spin__line--3">
												<div className="spin__total-medal spin__total-medal--3">
													<div>
														<img
															src="/images/medal-random.png"
															alt=""
															className="medal-random no-margin"
														/>
														<span>#</span>
													</div>
													<div>
														<img
															src="/images/medal-random.png"
															alt=""
															className="medal-random no-margin"
														/>
														<span>#</span>
													</div>
													<div>
														<img
															src="/images/medal-random.png"
															alt=""
															className="medal-random no-margin"
														/>
													</div>
													<p>3 huy hiệu khác nhau</p>
												</div>
												<div className="spin__wrap-rewards spin__wrap-rewards--3">
													{rewards1Medals &&
														rewards1Medals?.rewards.length > 0 &&
														rewards1Medals?.rewards.map((reward, index) => {
															const isActive = rewardsSpin.includes(reward?.id)
																? true
																: false;
															return (
																<div key={index}>
																	<img
																		src={lib.replaceNewString(
																			reward?.image,
																			'.png',
																			'_s.png'
																		)}
																		alt=""
																		data-tip={reward?.desc}
																		className={isActive ? ' active' : ''}
																	/>
																</div>
															);
														})}
												</div>
												<div className="spin__point spin__point--2">
													Điểm <br />+{rewards1Medals?.accumulation_point}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				)}
			</div>
			<ReactTooltip id="guide-text-free" place="right">
				Ưu đãi 11.11 - Chơi 1 được 2 <br />
				Lưu ý: <br />- Vào ngày này bạn sẽ được nhân đôi quà với lần chơi miễn
				phí đầu tiên trong ngày.
				<br />
				- Ưu đãi này chỉ được 1 lần duy nhất trong suốt sự kiện.
				<br />- Không áp dụng cho x2 điểm Lucky Star. <br />
				- VD: Bạn chơi miễn phí đầu tiên trong ngày thì sau khi nhận món quà bạn
				sẽ được x2 - 1 món quà đã nhận, nhưng không x2 điểm Lucky Star.
				<br /> Sau khi nhận ưu đãi thì sẽ trở về bình thường.
				{/* Sự kiện đặc biệt ngày 11.11 - Chơi 1 được 2.
				<br />
				Vào ngày này khi chơi 1 lần, 10 lần, 50 lần sẽ nhân đôi quà. <br />
				Lưu ý:
				<br />
				- Mỗi mệnh giá chỉ được áp dụng ưu đãi chơi 1 được 2 - 1 lần duy nhất
				<br />
				- Chỉ áp dụng cho chơi bằng FC <br />
				- Không áp dụng cho x2 điểm Lucky Star
				<br />
				- VD: Bạn chọn 10 lần thì sau khi nhận 10 món quà bạn sẽ được x2 - 10
				món quà đã nhận, nhưng không x2 điểm Lucky Star.
				<br /> Sau khi nhận ưu đãi thì các mệnh giá sẽ trở về bình thường. */}
			</ReactTooltip>
			<ReactTooltip id="guide-text-first-time">
				Sự kiện đặc biệt ngày 11.11 - Chơi 1 được 2. <br />
				Bạn cần chơi lần đầu xong để tham gia sự kiện
			</ReactTooltip>

			<ReactTooltip id="guide-text-special-day">
				Sự kiện đặc biệt ngày 11.11 - Chơi 1 được 2.
				<br />
				Vào ngày này khi chơi 1 lần, 10 lần, 50 lần sẽ nhân đôi quà. <br />
				Lưu ý:
				<br />
				- Mỗi mệnh giá chỉ được áp dụng ưu đãi chơi 1 được 2 - 1 lần duy nhất
				<br />
				- Chỉ áp dụng cho chơi bằng FC <br />
				- Không áp dụng cho x2 điểm Lucky Star
				<br />
				- VD: Bạn chọn 10 lần thì sau khi nhận 10 món quà bạn sẽ được x2 - 10
				món quà đã nhận, nhưng không x2 điểm Lucky Star.
				<br /> Sau khi nhận ưu đãi thì các mệnh giá sẽ trở về bình thường.
			</ReactTooltip>
			<ReactTooltip id="guide-club">
				Ưu đãi khi tạo CLB 23.4 - 12.5 ( Tối đa: 1 lần)
			</ReactTooltip>

			{modalMission && (
				<ModalMission
					modalStatus={modalMission}
					closeModal={closeModalMission}
					checkMatch={checkMatch}
					isCheckingMatch={isCheckingMatch}
					playNormal={playMatch}
				/>
			)}
			{showModalReceivedGift && gifts.length === 1 && (
				<ModalReceivedGift
					modalStatus={showModalReceivedGift}
					closeModal={() => setShowModalReceivedGift(false)}
					gifts={gifts}
				/>
			)}

			{showModalReceivedGifts && gifts.length > 1 && (
				<ModalReceivedGifts
					modalStatus={showModalReceivedGifts}
					closeModal={() => setShowModalReceivedGifts(false)}
					gifts={gifts}
				/>
			)}
			{modalJackpot && (
				<ModalJackpot
					modalStatus={modalJackpot}
					closeModal={closeModalJackpot}
					gifts={gifts}
				/>
			)}
		</>
	);
};

export default Spin;
